
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { canBookInStorages, hasSelfServiceAccess as hasSelfServiceAccess_1, allowsInAnyStorageOf, usePermissions } from "../../UserPermissions.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray, singleton as singleton_1, toArray as toArray_1, map, isEmpty, length, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { maxSelectedIds } from "../../Shared/MultiOperation.js";
import { toast } from "react-hot-toast";
import { createObj, stringHash, curry3 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { LabelInventoryKind, activeConfiguration } from "../../Shared/Label.js";
import { Permissions_has, Permission } from "../../Shared/Roles.js";
import { logoUrlFor, PrintLabelsModalSheet, printItem } from "../../Labels/PrintLabelsDialog.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { unwrapConsumableId } from "../../Shared/Helper.js";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";
import { toList, empty as empty_1, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { defaultFilterNames, resolve, name as name_6 } from "../../InventoryStates/Display.js";
import { ofConsumableState } from "../../Shared/InventoryStateMapping.js";
import { Table_customPropertyColumnDefinitions } from "../../Widgets/CustomProperties.js";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import Following from "../../../public/assets/icons/Following.svg";
import Followers from "../../../public/assets/icons/Followers.svg";
import { defaultArg, map as map_1, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Msg } from "./Types.js";
import { MultiAssignModalSheet } from "../../Widgets/Modals/MultiAssignModal.js";
import { MultiUnassignModalSheet } from "../../Widgets/Modals/MultiUnassignModal.js";
import { MultiReservationModalSheet } from "../../Widgets/Modals/MultiReservationModal.js";
import { MultiReminderModalSheet } from "../../Widgets/Modals/MultiReminderModal.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { InventoryStateDefinitionModule_systemDefinitions, InventoryKind } from "../../Shared/InventoryStates.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { SWR_getStates } from "../../Requests/InventoryStates.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { Button } from "../../Components/Button.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import { Skeleton } from "../../Components/Skeleton.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initOverview } from "./State.js";

export function ConsumablesTable(props) {
    const patternInput = useTranslation();
    const t = patternInput[0];
    const permissions = usePermissions();
    const patternInput_1 = reactApi.useState([false, [empty(), empty(), empty()]]);
    const isAssignModalSheetOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState([false, [empty(), empty(), empty()]]);
    const isUnassignModalSheetOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState([false, empty()]);
    const isMultipleReservationConsumableModalSheetOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState([false, empty()]);
    const isMultipleReminderConsumableModalSheetOpen = patternInput_4[0];
    const patternInput_5 = reactApi.useState([false, empty()]);
    const setIsPrintLabelsDialogOpen = patternInput_5[1];
    const isPrintLabelsDialogOpen = patternInput_5[0];
    const withinSelectionLimit = (selectedCount, setIsOpen, _arg) => {
        let arg_1;
        const selection = _arg[1];
        const isOpen = _arg[0];
        const count = selectedCount(selection) | 0;
        if (isOpen && (count > maxSelectedIds)) {
            toast.error((arg_1 = {
                count: count,
                max: maxSelectedIds,
            }, patternInput[1].t("multi_operation.too_many_elements", arg_1)));
        }
        else {
            setIsOpen([isOpen, selection]);
        }
    };
    const consumableCount = (_arg_1) => (length(_arg_1[2]) | 0);
    const setIsAssignModalSheetOpen_1 = curry3(withinSelectionLimit)(consumableCount)(patternInput_1[1]);
    const setIsUnassignModalSheetOpen_1 = curry3(withinSelectionLimit)(consumableCount)(patternInput_2[1]);
    const setIsMultipleReservationToolModalSheetOpen_1 = curry3(withinSelectionLimit)((list) => (length(list) | 0))(patternInput_3[1]);
    const setIsMultipleReminderConsumableModalSheetOpen_1 = curry3(withinSelectionLimit)((list_1) => (length(list_1) | 0))(patternInput_4[1]);
    const canPrintLabels = (activeConfiguration(props.CustomerConfiguration) != null) && allowsInAnyStorageOf(permissions, new Permission(24, []), props.UserData.UserId, props.Storages);
    const canAssignPrintedCodes = allowsInAnyStorageOf(permissions, new Permission(22, []), props.UserData.UserId, props.Storages);
    const printLabelsAction = new TableControl$1(t("labels.print.action_multiple"), undefined, (consumables) => {
        if (isEmpty(consumables)) {
        }
        else {
            setIsPrintLabelsDialogOpen([true, map((entityId) => printItem(new LabelInventoryKind(3, []), entityId), List_distinct(map((consumable) => unwrapConsumableId(consumable.Id), consumables), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }))]);
        }
    }, true, false, "consumables-overview-print-labels-action");
    const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(6, [dto.ImageUrl])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("name", t("general.master_data"), t("general.name"), (consumable_1) => (new CellContent(0, [consumable_1.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("additional_name", t("general.master_data"), t("consumable.additional_name"), (consumable_2) => (new CellContent(0, [consumable_2.AdditionalName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventory_number", t("general.master_data"), t("consumable.inventory_number"), (consumable_3) => (new CellContent(0, [consumable_3.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("description", t("general.master_data"), t("general.description"), (consumable_4) => (new CellContent(0, [consumable_4.Description])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("label", t("general.master_data"), t("tool.label"), (consumable_5) => (new CellContent(4, [consumable_5.Labels])), "categorySelect", "text")), delay(() => append(props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnit", t("general.master_data"), t("business_units.business_unit"), (consumable_6) => (new CellContent(0, [consumable_6.BusinessUnitName])), "select", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("location", t("general.master_data"), t("general.location"), (consumable_7) => (new CellContent(0, [consumable_7.Location])), "locationSelect", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", t("general.master_data"), t("general.storage"), (consumable_8) => (new CellContent(0, [consumable_8.Storage])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("StorageSpace", t("general.master_data"), t("tool.storage_space"), (consumable_9) => (new CellContent(0, [consumable_9.StorageSpace])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("storageStock", t("general.master_data"), t("general.stock"), (consumable_10) => (new CellContent(0, [concat(consumable_10.StorageStock, " ", ...t(Helper_unitToTranslationKey(consumable_10.Unit)))])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("stockQuantity", t("general.master_data"), t("dashboard.minimum_stock"), (dto_1) => (new CellContent(0, [dto_1.MinimumStorageStock])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", t("general.master_data"), t("general.qr_code"), (consumable_11) => (new CellContent(0, [consumable_11.QRCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("state", t("general.master_data"), t("general.state"), (consumable_12) => (new CellContent(0, [name_6(t, resolve(props.Definitions, consumable_12.StateKey, ofConsumableState(consumable_12.State)))])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("purchase_price", t("tool.commercial_data"), t("general.purchase_price"), (consumable_13) => (new CellContent(0, [consumable_13.PurchasePrice])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("purchaseDate", t("tool.commercial_data"), t("general.purchase_date"), (consumable_14) => (new CellContent(8, [consumable_14.PurchaseDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("supplier", t("tool.commercial_data"), t("general.supplier"), (consumable_15) => (new CellContent(0, [consumable_15.Supplier])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("supplier_artice_number", t("tool.commercial_data"), t("general.supplier_article_number"), (consumable_16) => (new CellContent(0, [consumable_16.SupplierArticleNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("warranty_date", t("tool.commercial_data"), t("general.gurantee_date"), (consumable_17) => (new CellContent(8, [consumable_17.WarrantyDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("commercial_data_comment", t("tool.commercial_data"), t("general.comment"), (consumable_18) => (new CellContent(0, [consumable_18.CommercialDataComment])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("lastSeen", t("general.master_data"), t("general.last_seen"), (consumable_19) => (new CellContent(8, [consumable_19.LastSeen])), "dateRange", "date")), delay(() => Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto_2) => dto_2.CustomProperties, t, props.CustomerConfiguration.Currency)))))))))))))))))))))))))))))))))))))))))))));
    const hasSelfServiceAccess = hasSelfServiceAccess_1(props.CustomerConfiguration, props.UserData.UserId, props.Storages);
    const canAssign = canBookInStorages(permissions, new Permission(6, []), props.UserData.UserId, props.Storages, hasSelfServiceAccess);
    const canTakeBack = canBookInStorages(permissions, new Permission(7, []), props.UserData.UserId, props.Storages, hasSelfServiceAccess && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification);
    const reserveAction = new TableControlElement$1(0, [new TableControl$1(t("general.reserve"), Calendar_Add(), (selectedConsumables) => {
        if (isEmpty(selectedConsumables)) {
        }
        else {
            setIsMultipleReservationToolModalSheetOpen_1([true, map((selectedConsumable) => selectedConsumable.Id, selectedConsumables)]);
        }
    }, true, false, "consumables-overview-reserve-action")]);
    const reminderAction = new TableControlElement$1(0, [new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (selectedConsumables_1) => {
        if (isEmpty(selectedConsumables_1)) {
        }
        else {
            setIsMultipleReminderConsumableModalSheetOpen_1([true, map((selectedConsumable_1) => selectedConsumable_1.Id, selectedConsumables_1)]);
        }
    }, true, false, "consumables-overview-reminder-action")]);
    const assignAction = new TableControlElement$1(0, [new TableControl$1(t("general.assign"), Following(), (selectedConsumables_2) => {
        if (isEmpty(selectedConsumables_2)) {
        }
        else {
            setIsAssignModalSheetOpen_1([true, [empty(), empty(), map((consumable_20) => consumable_20.Id, selectedConsumables_2)]]);
        }
    }, true, false, "consumables-overview-assign-action")]);
    const takeBackAction = new TableControlElement$1(0, [new TableControl$1(t("general.take_back"), Followers(), (consumables_1) => {
        if (isEmpty(consumables_1)) {
        }
        else {
            setIsUnassignModalSheetOpen_1([true, [empty(), empty(), map((consumable_21) => consumable_21.Id, consumables_1)]]);
        }
    }, true, false, "consumables-overview-take-back-action")]);
    const xs_1 = toList(delay(() => {
        let matchValue, labelConfiguration, labelConfiguration_1;
        return append((matchValue = activeConfiguration(props.CustomerConfiguration), (matchValue != null) ? (((labelConfiguration = matchValue, isPrintLabelsDialogOpen[0])) ? ((labelConfiguration_1 = matchValue, singleton(createElement(PrintLabelsModalSheet, {
            CanAssignCodes: canAssignPrintedCodes,
            Configuration: labelConfiguration_1,
            IsOpen: isPrintLabelsDialogOpen[0],
            Items: isPrintLabelsDialogOpen[1],
            LogoUrl: unwrap(logoUrlFor(props.CustomerConfiguration)),
            OnClose: () => {
                setIsPrintLabelsDialogOpen([false, empty()]);
            },
            OnPrinted: () => {
                props.Dispatch(new Msg(0, []));
            },
        })))) : (empty_1())) : (empty_1())), delay(() => append(singleton(createElement(MultiAssignModalSheet, {
            AssignProps: {
                ConsumableIds: isAssignModalSheetOpen[1][2],
                SetIds: empty(),
                ToolIds: empty(),
            },
            CustomerConfiguration: props.CustomerConfiguration,
            IsOpen: isAssignModalSheetOpen[0],
            OnClose: () => {
                setIsAssignModalSheetOpen_1([false, [empty(), empty(), empty()]]);
            },
            PredefinedQuantities: empty(),
            SuccessCallback: () => {
                props.Dispatch(new Msg(0, []));
            },
            UserData: props.UserData,
        })), delay(() => append(singleton(createElement(MultiUnassignModalSheet, {
            AllowStorageChange: false,
            CustomerConfiguration: props.CustomerConfiguration,
            IsOpen: isUnassignModalSheetOpen[0],
            OnClose: () => {
                setIsUnassignModalSheetOpen_1([false, [empty(), empty(), empty()]]);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(0, []));
            },
            UnassignProps: {
                ConsumableIds: isUnassignModalSheetOpen[1][2],
                SetIds: empty(),
                ToolIds: empty(),
            },
            UserData: props.UserData,
        })), delay(() => append(singleton(createElement(MultiReservationModalSheet, {
            CustomerConfiguration: props.CustomerConfiguration,
            IsOpen: isMultipleReservationConsumableModalSheetOpen[0],
            OnClose: () => {
                setIsMultipleReservationToolModalSheetOpen_1([false, empty()]);
            },
            ReservationProps: {
                ConsumableIds: isMultipleReservationConsumableModalSheetOpen[1],
                SetIds: empty(),
                ToolIds: empty(),
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(0, []));
            },
            UserData: props.UserData,
        })), delay(() => append(singleton(createElement(MultiReminderModalSheet, {
            CustomerConfiguration: props.CustomerConfiguration,
            IsOpen: isMultipleReminderConsumableModalSheetOpen[0],
            OnClose: () => {
                setIsMultipleReminderConsumableModalSheetOpen_1([false, empty()]);
            },
            ReminderProps: {
                ConsumableIds: isMultipleReminderConsumableModalSheetOpen[1],
                SetIds: empty(),
                ToolIds: empty(),
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(0, []));
            },
            UserData: props.UserData,
        })), delay(() => {
            let elems, TableRows, Options;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "[&>div]:h-full"])], (elems = [createElement(InfiniteTable, (TableRows = toArray_1(props.Consumables), (Options = {
                BorderStyle: "full",
                CSVDownload: true,
                ConfigurableColumns: true,
                CustomTableFilters: true,
                DefaultColumnFilter: singleton_1({
                    id: "state",
                    value: defaultFilterNames(t, singleton_1(new InventoryKind(3, [])), props.Definitions),
                }),
                DefaultSortColumn: ["name", "asc"],
                Fullscreen: false,
                GlobalSearch: true,
                OnRowClick: new OnTableRowClick$1(1, [(consumable_22) => RouterModule_encodeParts(ofArray(["consumables", unwrapConsumableId(consumable_22.Id) + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1)]),
                RowSelection: "multiRow",
                SaveTableConfiguration: true,
                WithQueryParameters: true,
            }, {
                ColumnDefinitions: columnDefinitions,
                Controls: toList(delay(() => append(canAssign ? singleton(assignAction) : empty_1(), delay(() => append(canTakeBack ? singleton(takeBackAction) : empty_1(), delay(() => append(Permissions_has(permissions, new Permission(11, [])) ? singleton(reserveAction) : empty_1(), delay(() => append(allowsInAnyStorageOf(permissions, new Permission(19, []), props.UserData.UserId, props.Storages) ? singleton(reminderAction) : empty_1(), delay(() => (canPrintLabels ? singleton(new TableControlElement$1(1, [t("table.more"), "consumables-overview-more-actions", singleton_1(printLabelsAction)])) : empty_1()))))))))))),
                Options: Options,
                TableKey: "consumables-table",
                TableRows: TableRows,
            })))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }))))))))));
    }));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function ConsumablesOverview(props) {
    let elems_4, elems_2, elems_3;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const states = SWR_getStates();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-y-2", "pb-2", "shrink-0"])], (elems_2 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: false,
                Label: t("general.tool"),
                OnClick: () => {
                    RouterModule_nav(ofArray(["tools"]), 1, 1);
                },
                TestId: "overview-tab-tools",
            }, {
                IsSelected: true,
                Label: t("general.consumable"),
                OnClick: () => {
                    RouterModule_nav(ofArray(["consumables"]), 1, 1);
                },
                TestId: "overview-tab-consumables",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["grow"]),
        })), delay(() => {
            let elems_1, Label_2;
            return allowsInAnyStorageOf(permissions, new Permission(1, []), props.UserData.UserId, props.Storages) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["shrink-0"])], (elems_1 = [createElement(Button, (Label_2 = t("consumable.create_new_consumable"), {
                ComponentState: "enabled",
                Icon: Shipment_Add(),
                Label: Label_2,
                OnClick: () => {
                    RouterModule_nav(ofArray(["consumables", "new"]), 1, 1);
                },
                TestId: "add-new-consumables-button",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty_1();
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["data-test-id", "consumables-overview-inventory-table"], ["className", join(" ", ["flex-1", "min-h-0"])], (elems_3 = toList(delay(() => {
        const matchValue = map_1((_arg_3) => _arg_3.States, states.data);
        let matchResult, definitions;
        if (matchValue == null) {
            if (states.error == null) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
                definitions = matchValue;
            }
        }
        else {
            matchResult = 1;
            definitions = matchValue;
        }
        switch (matchResult) {
            case 0:
                return singleton(createElement(Skeleton, {
                    Variant: "table",
                }));
            default:
                return singleton(createElement(ConsumablesTable, {
                    AccountSettings: props.AccountSettings,
                    Consumables: props.Consumables,
                    Customer: props.Customer,
                    CustomerConfiguration: props.CustomerConfiguration,
                    Definitions: defaultArg(definitions, InventoryStateDefinitionModule_systemDefinitions),
                    Dispatch: props.Dispatch,
                    PropertyConfigurations: props.PropertyConfigurations,
                    Storages: props.Storages,
                    UserData: props.UserData,
                }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function ConsumablesOverviewView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initOverview(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, usePermissions()], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Consumables;
    const matchValue_1 = state_1.PropertyConfigurations;
    const matchValue_2 = state_1.CustomerConfiguration;
    const matchValue_3 = state_1.Storages;
    let matchResult, consumables, customerConfiguration, propertyConfigurations, storages;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        consumables = matchValue.fields[0];
        customerConfiguration = matchValue_2.fields[0];
        propertyConfigurations = matchValue_1.fields[0];
        storages = matchValue_3.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ConsumablesOverview, {
                AccountSettings: props.AccountSettings,
                Consumables: consumables,
                Customer: state_1.Customer,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                PropertyConfigurations: propertyConfigurations,
                Storages: storages,
                UserData: state_1.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

